import Client from '../HttpClient';

const baseUrl = '/gateway/kiwi-api/api/vs/manage-voucher';

const list = (payload) => {
	return Client.get(`${baseUrl}/vouchers`, payload);
};

const find = (id) => {
	return Client.get(`${baseUrl}/voucherApply/${id}`);
};

const transactions = (id) => {
	return Client.get(`${baseUrl}/voucher/transactions/${id}`);
};

export default {
	list,
	find,
	transactions,
};
